import { Component } from '@angular/core'
import { environment } from '@cr-environments/environment'
import { TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'app-footer',
  imports: [TranslateModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  protected readonly environment = environment
}
